module.exports = __webpack_public_path__ + "img/photo-69.8636c490.webp";